module.exports = __webpack_public_path__ + "img/marker-unpublished.9967faca.svg";